import { titleize } from 'inflected'

export const FILTER = function (text) {
  if (typeof text !== 'undefined' && text !== null) {
    text = titleize(text)
  }
  return text
}

export default {
  install (Vue) {
    Vue.filter('titleize', FILTER)
  }
}
